import { PAGE_PARAM } from 'constants/pageParam';
import { useSearchParams } from 'react-router-dom';

export const usePageParam = () => {
	const [searchParams, setSearchParams] = useSearchParams();

	const setPageParam = (pageName: string) => {
		const newSearchParams = new URLSearchParams(searchParams.toString());
		newSearchParams.set(PAGE_PARAM, pageName);
		setSearchParams(newSearchParams);
	};

	const getPageParam = () => {
		const paramKey = PAGE_PARAM?.toLowerCase() || PAGE_PARAM;
		const paramValue = searchParams.get(paramKey);

		return paramValue?.toLowerCase() ?? paramValue;
	};

	return { setPageParam, getPageParam };
};
